// extracted by mini-css-extract-plugin
export default {"change_page_icon_next":"Paginator_change_page_icon_next__H4nMV","change_page_icon_prev":"Paginator_change_page_icon_prev__na1o-"};